export const PRODUCTS={
    FETCH_SUCCESS:"FetchProducts",
    FETCH_ERROR:"FetchError"

}